// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cabinetListCard{width:100%;overflow:hidden;position:relative;padding:10px 0;float:left}.fontBold{font-weight:700}", ""]);
// Exports
module.exports = exports;
